<div
  class="font-roboto-700 text-blue-o-50 my-4 p-4 max-sm:p-3 text-center max-sm:my-2"
  *ngIf="h2hStatics.info.length === 0"
>
  {{ "NotAvalaibleInformation" | translate }}
</div>

<div
  *ngIf="h2hStatics.info.length > 0"
  class="bg-red-4 font-roboto-500 text-16 rounded-5 p-5 text-grey-1 mb-3 max-sm:text-13 max-sm:p-3 capitalize"
>
  {{ "LastMatches" | translate }}{{ h2hStatics.name }}
</div>

<div class="flex flex-col gap-3 text-grey-2 font-roboto-600">
  <div
    class="grid grid-cols-7 gap-3 items-center cursor-pointer hover:bg-grey-5 dark:hover:bg-grey-13 p-1 rounded-5 max-sm:text-11"
    *ngFor="
      let match of h2hStatics.info
        | slice : 0 : (moreMatches ? 5 : h2hStatics.info.length)
    "
    (click)="matchSelected(match)"
  >
    <div
      class="grid grid-cols-2 max-sm:flex max-sm:gap-1 max-sm:flex-col col-span-3 items-center max-sm:items-start max-sm:col-span-2"
    >
      <div>
        {{ match.matchDate }}
      </div>
      <div class="flex gap-2 items-center max-sm:gap-1">
        <img
          alt="logo"
          class="w-[24px] h-[24px] max-sm:w-[18px] max-sm:h-[18px] object-contain"
          [src]="
            match.competition[0].logo != ''
              ? match.competition[0].logo
              : urlIMG + 'default.png'
          "
        />
        {{ match.competition[0].shortName }}
      </div>
    </div>

    <div
      class="flex flex-col gap-3 max-sm:gap-1 text-blue col-span-3 max-sm:col-span-4"
    >
      <div class="grid grid-cols-12">
        <div class="col-span-2">
          <img
            alt="logo"
            class="w-[24px] h-[24px] max-sm:w-[18px] max-sm:h-[18px] object-contain"
            [src]="
              match.dataHome.logo != ''
                ? match.dataHome.logo
                : urlIMG + 'default.png'
            "
          />
        </div>
        <div
          class="col-span-9"
          [ngClass]="{
            'winner-team': match.dataHome.scoreHome > match.dataAway.scoreAway
          }"
        >
          {{ match.dataHome.name }}
        </div>
        <div
          class="col-span-1 text-end"
          [ngClass]="{
            'winner-team': match.dataHome.scoreHome > match.dataAway.scoreAway
          }"
        >
          {{ match.dataHome.scoreHome }}
        </div>
      </div>
      <div class="grid grid-cols-12">
        <div class="col-span-2">
          <img
            alt="logo"
            class="w-[24px] h-[24px] max-sm:w-[18px] max-sm:h-[18px] object-contain"
            [src]="
              match.dataAway.logo != ''
                ? match.dataAway.logo
                : urlIMG + 'default.png'
            "
          />
        </div>
        <div
          class="col-span-9"
          [ngClass]="{
            'winner-team': match.dataHome.scoreHome < match.dataAway.scoreAway
          }"
        >
          {{ match.dataAway.name }}
        </div>
        <div
          class="col-span-1 text-end"
          [ngClass]="{
            'winner-team': match.dataHome.scoreHome < match.dataAway.scoreAway
          }"
        >
          {{ match.dataAway.scoreAway }}
        </div>
      </div>
    </div>

    <div class="font-roboto-600 flex justify-end">
      <div
        class="rounded-full max-w-[50px] flex justify-center items-center text-white w-full p-3"
        *ngIf="match.result != ''"
        [ngClass]="{
          'bg-green-1': match.result === 'W',
          'bg-red-2': match.result === 'L',
          'bg-grey-1': !['W', 'L'].includes(match.result)
        }"
      >
        {{ match.result | translate }}
      </div>
    </div>
  </div>
</div>

<div
  class="flex justify-center"
  *ngIf="moreMatches && h2hStatics.info.length > 0"
>
  <button
    class="flex gap-1 items-center text-red-2 p-3 font-roboto-500"
    (click)="moreMatches = !moreMatches"
  >
    <span>{{ "ShowMoreMatches" | translate }}</span>
    <img alt="logo" [src]="urlIMG + 'icons/add.svg'" />
  </button>
</div>
